import './carousel.scss';

import React, { useContext, useEffect } from 'react';

import { isTouchCapable } from '../../../services/utilities';
import { CaretDisplayOption } from '../../../types/types';
import { Swipeable } from '../Swipeable/Swipeable';
import { CarouselCarets } from './CarouselCarets';
import { carouselContext, CarouselContext } from './carouselContext';
import { CarouselDotGroup } from './CarouselDotGroup';

export const CarouselSlide = (
    { tag, children, withCaret, withDotGroup, withFading }:
        { tag?: string; withDotGroup?: boolean; withCaret?: CaretDisplayOption; withFading?: boolean; children: React.ReactNode[] }) => {

    const nChildren = children.length;
    const { nSlides, setNSlides, name, activeIndex, gotoNextSlide, gotoPreviousSlide } = useContext<CarouselContext>(carouselContext);


    useEffect(() => {
        if (nChildren !== nSlides) {
            console.log('CarouselScroll: nChildren != nSlides', nChildren, nSlides);
            setNSlides(nChildren);
        }
    }, []);


    const getId = (index: number) => {
        let nameTag = name ? name : 'carousel';
        if (tag) {
            nameTag = `${nameTag}_${tag}`;
        }
        return `${nameTag}_${index}`;
    };

    if (nChildren == 0)
        return null;

    const showCaret = withCaret == 'Always' || (withCaret == 'NonTouch' && !isTouchCapable());

    return (
        // <carouselContext.Provider value={{ setNSlides, name, looping: looping, nSlides: nChildren, activeIndex, gotoSlide, gotoPreviousSlide, gotoNextSlide }} >
        <>
            <div data-testid='carousel-stage' className='stage'>
                <Swipeable onSwipedLeft={gotoNextSlide} onSwipedRight={gotoPreviousSlide} swipeableClass='w-100 position-relative'>
                    {children.map((slide, index) =>
                        <div data-testid='carousel-slide'
                            className={`w-100 slide ${index == activeIndex ? 'active' : 'non-active'} ${withFading ? 'fading' : ''}`}
                            key={index}
                            id={getId(index)}
                            aria-hidden={activeIndex != index}
                        >
                            {slide}
                        </div>)
                    }
                    {showCaret && <CarouselCarets />}
                </Swipeable>
            </div>
            {withDotGroup && <CarouselDotGroup />}
        </>
        // </carouselContext.Provider >
    );
};

